export default __webpack_public_path__ + "static/media/dockercertifiedimg.b76e06aa.png";